/* === Product Card Carousel JS — Lazy Load on Interaction === */

(function () {

  var isDesktop = function () { return window.innerWidth >= 768; };



  function loadDeferred(carousel) {

    var tmpl = carousel.querySelector('.pcard-carousel__deferred');

    if (!tmpl) return false;

    var track = carousel.querySelector('.pcard-carousel__track');

    var content = tmpl.content.cloneNode(true);

    track.appendChild(content);

    tmpl.remove();

    /* Force reflow so slides are measurable */

    track.offsetHeight;

    return true;

  }



  function initCarousels() {

    document.querySelectorAll('.pcard-carousel').forEach(function (carousel) {

      if (carousel.dataset.mode) return;



      var track = carousel.querySelector('.pcard-carousel__track');

      var dots = carousel.querySelectorAll('.pcard-carousel__dot');



      if (!track) return;



      var currentIdx = 0;



      function setActive(idx) {

        var slides = carousel.querySelectorAll('.pcard-carousel__slide');

        if (idx === currentIdx && slides.length > 1) return;

        currentIdx = idx;

        for (var i = 0; i < slides.length; i++) {

          slides[i].classList.toggle('is-active', i === idx);

          if (i === 0) {

            slides[i].style.opacity = (idx === 0) ? '' : '0';

          }

        }

        for (var j = 0; j < dots.length; j++) {

          dots[j].classList.toggle('active', j === idx);

        }

      }



      if (isDesktop()) {

        carousel.dataset.mode = 'desktop';

        var hoverTarget = carousel.closest('.product-card__image-wrapper') || carousel;



        hoverTarget.addEventListener('mouseenter', function () {

          if (!carousel.dataset.loaded) {

            loadDeferred(carousel);

            carousel.dataset.loaded = '1';

          }

        }, { once: true });



        hoverTarget.addEventListener('mousemove', function (e) {

          /* If not loaded yet, skip */

          if (!carousel.dataset.loaded) return;



          var slides = carousel.querySelectorAll('.pcard-carousel__slide');

          var count = slides.length;

          if (count < 2) return;



          var rect = hoverTarget.getBoundingClientRect();

          var x = e.clientX - rect.left;

          var pct = x / rect.width;

          var idx = Math.min(Math.floor(pct * count), count - 1);

          if (idx < 0) idx = 0;

          setActive(idx);

        });



        hoverTarget.addEventListener('mouseleave', function () {

          currentIdx = -1;

          setActive(0);

        });



        for (var i = 0; i < dots.length; i++) {

          (function (idx) {

            dots[idx].addEventListener('click', function (e) {

              e.preventDefault();

              e.stopPropagation();

              if (!carousel.dataset.loaded) {

                loadDeferred(carousel);

                carousel.dataset.loaded = '1';

              }

              setActive(idx);

            });

          })(i);

        }



        setActive(0);



      } else {

        carousel.dataset.mode = 'mobile';

        var touchLoaded = false;



        track.addEventListener('touchstart', function () {

          if (!touchLoaded) {

            loadDeferred(carousel);

            carousel.dataset.loaded = '1';

            touchLoaded = true;

            initMobileObserver();

          }

        }, { passive: true, once: true });



        function initMobileObserver() {

          var slides = carousel.querySelectorAll('.pcard-carousel__slide');

          var observer = new IntersectionObserver(

            function (entries) {

              entries.forEach(function (entry) {

                if (entry.isIntersecting) {

                  var idx = entry.target.dataset.slideIndex;

                  dots.forEach(function (d) {

                    d.classList.toggle('active', d.dataset.dotIndex === idx);

                  });

                }

              });

            },

            { root: track, threshold: 0.6 }

          );

          slides.forEach(function (slide) { observer.observe(slide); });

        }



        dots.forEach(function (dot) {

          dot.addEventListener('click', function (e) {

            e.preventDefault();

            e.stopPropagation();

            if (!carousel.dataset.loaded) {

              loadDeferred(carousel);

              carousel.dataset.loaded = '1';

              touchLoaded = true;

            }

            var idx = parseInt(dot.dataset.dotIndex, 10);

            var slides = carousel.querySelectorAll('.pcard-carousel__slide');

            if (slides[idx]) {

              track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });

            }

          });

        });

      }

    });

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', initCarousels);

  } else {

    initCarousels();

  }



  document.addEventListener('shopify:section:load', initCarousels);



  var targets = [document.getElementById('ProductGridContainer')];

  document.querySelectorAll('product-recommendations, product-slider').forEach(function (el) {

    targets.push(el);

  });

  targets.forEach(function (t) {

    if (t) new MutationObserver(initCarousels).observe(t, { childList: true, subtree: true });

  });

})();